import React from 'react';
import { Layout, Toaster } from 'components/core';
import { DownloadWithToken } from 'components/report/download/downloadWithToken';
import { WithSharedResourceDownload } from 'components/common/withSharedResourceDownload/withSharedResourceDownload';
import {
  FullScreenSpinner,
  useResolvedIsAuthenticated,
} from 'views/reports/authResolution';

export function DocumentDownloadView(): React.ReactElement {
  const isAuthenticated = useResolvedIsAuthenticated();

  if (isAuthenticated === undefined) {
    return (
      <FullScreenSpinner reason='DocumentDownloadView awaiting auth resolution' />
    );
  }

  return (
    <WithSharedResourceDownload entityType='document'>
      {isAuthenticated ? (
        <Layout>
          <DownloadWithToken />
        </Layout>
      ) : (
        <>
          <DownloadWithToken />
          <Toaster />
        </>
      )}
    </WithSharedResourceDownload>
  );
}
